import { render, staticRenderFns } from "./WorkerAdminData.vue?vue&type=template&id=e6d8ff54&"
import script from "./WorkerAdminData.vue?vue&type=script&lang=js&"
export * from "./WorkerAdminData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports